module.exports = __webpack_public_path__ + "img/img12.517a6ca2.png";